/** sessionStorage wrappers that never throw (SSR, private browsing, quota). */

export function safeSessionGet(key: string): string | null {
    try { return sessionStorage.getItem(key) } catch { return null }
}

export function safeSessionSet(key: string, value: string): void {
    try { sessionStorage.setItem(key, value) } catch { /* noop */ }
}

export function safeSessionRemove(key: string): void {
    try { sessionStorage.removeItem(key) } catch { /* noop */ }
}

export function readNumber(key: string): number | null {
    const raw = safeSessionGet(key)
    if (!raw) return null
    const n = Number(raw)
    return Number.isFinite(n) ? n : null
}

export function deltaMs(fromKey: string): number | null {
    const t = readNumber(fromKey)
    if (t == null) return null
    return Math.max(0, Math.round(Date.now() - t))
}

export function secondsSince(key: string): number | null {
    const ms = deltaMs(key)
    return ms == null ? null : Math.round(ms / 1000)
}
